// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Card_wrapper","icon":"Card_icon","disabled":"Card_disabled","is-empty":"Card_is-empty","isEmpty":"Card_is-empty"};